import { FieldConfig } from "~/components/Forms/DealerPassportForm2/types";

export const getDealerFields = (
  t: (key: string) => string,
  prefix: string,
): FieldConfig[] => [
  {
    name: `${prefix}reestrAddress`,
    label: t(`dealers.reestrAddress`),
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}address`,
    label: t(`dealers.address`),
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}country`,
    label: t(`dealers.country`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}fo`,
    label: t(`dealers.FO`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}subject`,
    label: t(`dealers.subject`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}locality`,
    label: t(`dealers.locality`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}city`,
    label: t(`dealers.city`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}street`,
    label: t(`dealers.street`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}district`,
    label: t(`dealers.district`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}house`,
    label: t(`dealers.house`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}office`,
    label: t(`dealers.office`),
    type: "text",
  },
  {
    name: `${prefix}index`,
    label: t(`dealers.index`),
    type: "text",
    disabled: true,
  },
];

export const getDealerCoordinats = (
  t: (key: string) => string,
  prefix: string,
): FieldConfig[] => [
  {
    name: `${prefix}latitude`,
    label: t(`dealers.latitude`),
    type: "number",
  },
  {
    name: `${prefix}longitude`,
    label: t(`dealers.longitude`),
    type: "number",
  },
];

export const getDealerXshop = (
  t: (key: string) => string,
  prefix: string,
): FieldConfig[] => [
  {
    name: `${prefix}Xshop`,
    label: t(`dealers.XwebName`),
    type: "text",
    // disabled: true,
  },
  {
    name: `${prefix}Name`,
    label: t(`dealers.xshop`),
    type: "text",
    // disabled: true,
  },
];

export const getDealerInfoMail = (
  t: (key: string) => string,
  prefix: string,
): FieldConfig[] => [
  {
    name: `${prefix}phoneCode`,
    label: t(`dealers.phoneCode`),
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}phone`,
    label: t(`dealers.phone`),
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}email`,
    label: t(`dealers.email`),
    type: "text",
    disabled: true,
  },
];

export const getDealerInfoLegal = (
  t: (key: string) => string,
  prefix: string,
): FieldConfig[] => [
  {
    name: `${prefix}address`,
    label: t(`dealers.address`),
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}index`,
    label: t(`dealers.index`),
    type: "text",
  },
  {
    name: `${prefix}country`,
    label: t(`dealers.country`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}fo`,
    label: t(`dealers.fo`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}subject`,
    label: t(`dealers.subject`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}district`,
    label: t(`dealers.district`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}locality`,
    label: t(`dealers.locality`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}city`,
    label: t(`dealers.city`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}street`,
    label: t(`dealers.street`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}house`,
    label: t(`dealers.house`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}office`,
    label: t(`dealers.office`),
    type: "text",
  },
];

export const getDealerInfoXweb = (
  t: (key: string) => string,
  prefix: string,
): FieldConfig[] => [
  {
    name: `${prefix}address`,
    label: t(`dealers.address`),
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}index`,
    label: t(`dealers.index`),
    type: "text",
  },
  {
    name: `${prefix}country`,
    label: t(`dealers.country`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}fo`,
    label: t(`dealers.fo`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}subject`,
    label: t(`dealers.subject`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}district`,
    label: t(`dealers.district`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}locality`,
    label: t(`dealers.locality`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}city`,
    label: t(`dealers.city`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}street`,
    label: t(`dealers.street`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}house`,
    label: t(`dealers.house`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}office`,
    label: t(`dealers.office`),
    type: "text",
  },
];
export const getDealerFieldsAsp = (
  t: (key: string) => string,
  prefix: string,
): FieldConfig[] => [
  {
    name: `${prefix}name`,
    label: t(`dealers.tradeName`),
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}address`,
    label: t(`dealers.address`),
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}country`,
    label: t(`dealers.country`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}fo`,
    label: t(`dealers.FO`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}subject`,
    label: t(`dealers.subject`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}locality`,
    label: t(`dealers.locality`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}city`,
    label: t(`dealers.city`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}street`,
    label: t(`dealers.street`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}district`,
    label: t(`dealers.district`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}house`,
    label: t(`dealers.house`),
    type: "select",
    options: [],
  },
  {
    name: `${prefix}office`,
    label: t(`dealers.office`),
    type: "text",
  },
  {
    name: `${prefix}index`,
    label: t(`dealers.index`),
    type: "text",
    disabled: true,
  },
];
export const getDealerInfoAsp = (
  t: (key: string) => string,
  prefix: string,
): FieldConfig[] => [
  {
    name: `${prefix}phoneCode`,
    label: t(`dealers.phoneCode`),
    type: "text",
  },
  {
    name: `${prefix}phone`,
    label: t(`dealers.phone`),
    type: "phone",
  },
  {
    name: `${prefix}email`,
    label: t(`dealers.email`),
    type: "email",
  },
];
